// import host from './baseUrl'
var Base64 = require('js-base64').Base64;
var md5 = require('md5');
// const axios = require('axios');

// async function autoLogin(p,en){
//   //  let phone=Base64.decode(p)
//    let phone=Base64.decode(decodeURIComponent(p))
//    console.log(phone)
//    const result = await axios.get(`${host}/system/wechat_app/user_info?phone=${phone}`).then((res) => {
//      return res.data.data;
//    });
//    return result;
//   //  let enHere =md5(phone+"autoLogin")
//   //  if(enHere == en){
//   //     await axios.get('http://guigui.admin.thinkerx.com/wechat_app/user_info?phone='+phone).then(resp=>{
//   //       let res=resp.data
//   //       if(res.status==1){
//   //         localStorage.setItem('data',JSON.stringify(res.data))
//   //       }
//   //     })
//   //  }else{
//   //    return
//   //  }
// }
function makeEnP(phone){
	let p=Base64.encode(phone)
	let en=md5(phone+"autoLogin")
	let str="p="+p+"&en="+en
	return str
}

function getUrlVars(){
	var vars = {}, hash;
	// var decodeUrl = decodeURI(window.location.href);
  let url=window.location.href
  let hashes=[]
  let temp1=url.split('#')
  if(temp1.length>1){
    let temp2=temp1[0].split('?')
    if(temp2.length>1){
      hashes=hashes=hashes.concat(temp2[1].split('&'))
    }
    temp2=temp1[1].split('?')
    if(temp2.length>1){
      hashes=hashes=hashes.concat(temp2[1].split('&'))
    }
  }else{
    hashes = url.slice(url.indexOf('?') + 1).split('&')
  }
	for (var i = 0; i < hashes.length; i++) {
	  hash = hashes[i].split('=');
	  // vars.push(hash[0]);
	  vars[hash[0]] = hash[1];
	}
	return vars;
}

function deleteEnP(){
  let param=getUrlVars()
  if(param.hasOwnProperty('p')){
    delete param.p
  }
  if(param.hasOwnProperty('en')){
    delete param.en
  }
  // console.log(param)
  let paramStr=[]
  for(let key in param){
    paramStr.push(key+"="+param[key])
  }
  paramStr=paramStr.join('&')
  let routerStr=''
  let router=window.location.href.split('#')
  if(router.length>1){
    router=router[1]
    router=router.split('?')
    router=router[0]
    routerStr=router
  }
  let href=window.location.href.split('?')[0].split('#')[0]
  let url=href+(paramStr?'?'+paramStr:'')+(routerStr?'#'+routerStr:'')
  return url
}

// async function getEnp() {
//   let userInfo = window.localStorage.getItem('data');
//   if (userInfo) {
//     let result = await this.axios.post(`${host}/system/eggrj/getEnP`).then((res) => {
//       if (res.data.data) {
//         return res.data.data;
//       }
//     });
//   }
//   return result ? result : '';
// }

// async function getSupplierInfo(uid){
//   var resp=await axios({
//     url:`${host}/guigui/cloudStorage/getSupplierInfo`,
//     method:"POST",
//     data:{
//        uid:uid
//     }
//   }).then(res=>{
//     return res.data.data
//   })
//   return resp
// }

export default {
  // autoLogin: autoLogin,
  makeEnP:makeEnP,
  // getEnp,
  getUrlVars,
  deleteEnP,
  // getSupplierInfo:getSupplierInfo
}
